import { useEffect, useState } from 'react';
import type { ChatMessage } from '../../types/agent';
import { turnElapsed } from '../../services/agent/ChatSession';

/** "8 s", "1 min 05 s": whole seconds, minutes past the first. */
export function formatDuration(ms: number): string {
  const s = Math.floor(ms / 1000);
  return s < 60 ? `${s} s` : `${Math.floor(s / 60)} min ${String(s % 60).padStart(2, '0')} s`;
}

/** How long the agent has been on this turn, ticking while it runs (paused while it waits on the user), then
 *  how long it took, which stays under the turn as the bare time — also on a turn restored from the history, which
 *  carries it when the pane reported it (`DisplayMessage.duration_ms`). */
export function TurnClock({ m }: { m: ChatMessage }) {
  const [now, setNow] = useState(() => Date.now());
  const ticking = !!m.pending && m.turnMs == null && m.turnStartedAt != null;
  useEffect(() => {
    if (!ticking) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [ticking]);
  const ms = turnElapsed(m, now);
  if (ms == null) return null;
  return (
    <span className="shrink-0 font-mono text-[11px] tabular-nums text-fainter" data-testid="turn-clock">
      {formatDuration(ms)}
    </span>
  );
}
